module.exports = __webpack_public_path__ + "static/media/check-white.9ad1d13c.svg";